import dataEventModel from '../data-event-model';

export default function processExpressions(results, callback, context) {
  const { currentRecord, elementsByKey } = context;
  const expressions = dataEventModel();
  const validations: string[] = [];

  results.forEach((result) => {
    switch (result.type) {
      case 'set-value':
        expressions.processSetValue(result, currentRecord, elementsByKey);
        break;

      case 'validation':
        // @ts-ignore
        validations.push(expressions.processValidation(result));
        break;

      default:
        break;
    }
  });

  callback(validations);
}
